function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import PropTypes from 'prop-types';
import { scopeFocus as scope, unscopeFocus as unscope } from 'a11y-focus-scope';
import { withOverlay } from './Overlay';
var Modal = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(Modal, _React$PureComponent);
  function Modal() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;
    _defineProperty(_assertThisInitialized(_this), "handleNode", function (node) {
      if (_this.props.scopeFocus && _this.node && node) {
        unscope(_this.node);
        scope(node);
      }
      _this.node = node;
    });
    _defineProperty(_assertThisInitialized(_this), "onDocClick", function (event) {
      if (!_this.props.noCloseOnBodyClick && !event.defaultPrevented && _this.node && _this.node !== event.target && !_this.node.contains(event.target) && _this.prevFocusEl !== event.target) {
        event.preventDefault();
        event.stopPropagation();
        _this.props.onRequestClose(false);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onDocKeyDown", function (event) {
      if (!_this.props.noCloseOnEscKey && !event.defaultPrevented && event.key === 'Escape') {
        event.preventDefault();
        _this.props.onRequestClose(true);
      }
    });
    return _this;
  }
  var _proto = Modal.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.prevFocusEl = document.activeElement;
    if (this.props.scopeFocus) {
      scope(this.node);
    }
    document.addEventListener('click', this.onDocClick, true);
    document.addEventListener('keydown', this.onDocKeyDown, true);
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    document.removeEventListener('click', this.onDocClick, true);
    document.removeEventListener('keydown', this.onDocKeyDown, true);
    if (this.props.scopeFocus) {
      unscope(this.node);
    }
    if (!this.props.noFocusRestore && document.activeElement === document.body) {
      this.prevFocusEl.focus();
    }
  };
  _proto.render = function render() {
    if (typeof this.props.children === 'function') {
      return this.props.children(_objectSpread({}, this.props, {
        ref: this.handleNode
      }));
    }
    var _this$props = this.props,
      children = _this$props.children,
      component = _this$props.component,
      currentModalId = _this$props.currentModalId,
      getIndexById = _this$props.getIndexById,
      isOpenById = _this$props.isOpenById,
      noCloseOnBodyClick = _this$props.noCloseOnBodyClick,
      noCloseOnEscKey = _this$props.noCloseOnEscKey,
      noFocusRestore = _this$props.noFocusRestore,
      onRequestClose = _this$props.onRequestClose,
      overlayId = _this$props.overlayId,
      overlayName = _this$props.overlayName,
      scopeFocus = _this$props.scopeFocus,
      props = _objectWithoutPropertiesLoose(_this$props, ["children", "component", "currentModalId", "getIndexById", "isOpenById", "noCloseOnBodyClick", "noCloseOnEscKey", "noFocusRestore", "onRequestClose", "overlayId", "overlayName", "scopeFocus"]);
    return React.createElement(component, _objectSpread({}, props, {
      ref: this.handleNode
    }), children);
  };
  return Modal;
}(React.PureComponent);
_defineProperty(Modal, "defaultProps", {
  component: 'div',
  role: 'popover'
});
process.env.NODE_ENV !== "production" ? Modal.propTypes = {
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  component: PropTypes.any,
  currentModalId: PropTypes.string.isRequired,
  getIndexById: PropTypes.func.isRequired,
  id: PropTypes.string,
  isOpenById: PropTypes.func.isRequired,
  noCloseOnBodyClick: PropTypes.bool,
  noCloseOnEscKey: PropTypes.bool,
  noFocusRestore: PropTypes.bool,
  onRequestClose: PropTypes.func,
  overlayId: PropTypes.string.isRequired,
  overlayName: PropTypes.string.isRequired,
  role: PropTypes.oneOf(['alert', 'listbox', 'menu', 'modal', 'popover', 'tooltip']),
  scopeFocus: PropTypes.bool
} : void 0;
export default withOverlay({
  identifier: 'modal'
})(Modal);